<template>
    <router-link v-if="tracked" :class="type" :to="to" v-popover:company="hidePopover ? undefined : company">
        {{ displayText }}
    </router-link>
    <span v-else-if="present" :class="type">
        {{ displayText }}
    </span>
</template>
<script>
export default {
    props: {
        company: {
            type: Object,
            default() {
                return null
            },
        },
        hidePopover: {
            type: Boolean,
            default: false,
        },
        name: {
            type: Boolean,
            default: false,
        },
        query: {
            type: Object,
            default() {
                return null
            },
        },
        symbol: {
            type: Boolean,
            default: false,
        },
        type: {
            type: String,
            default: 'primary-link',
        },
    },
    computed: {
        displayText() {
            const parts = []
            if (this.showName) {
                parts.push(this.company?.name)
            }
            if (this.symbol) {
                parts.push(this.company?.symbol)
            }
            return parts.filter(c => c).join(' | ')
        },
        showName() {
            return this.name || !this.symbol
        },
        to() {
            if (!this.company) {
                return null
            }

            return {
                name: 'company-page',
                params: { id: this.company.id },
                query: this.query,
            }
        },
        present() {
            return this.displayText.length > 0
        },
        tracked() {
            return this.present && (this.company?.tracked ?? false)
        },
    },
}
</script>
<style scoped>
span {
    font-weight: bold;
}

span.primary-link {
    color: var(--color-primary-800);
}

span.tertiary-link {
    font-weight: normal;
}
</style>
